module.exports = __webpack_public_path__ + "EFE8A526FA5D687D977B74FD9990AAC2plan5.28a4fdcd.png";